module.exports = __webpack_public_path__ + "static/media/VideoModal.4b41c159.css";